<template>
  <FilterParent module="Driver" maxWidth="500" v-model="showTransporterVehicleFilter">
    <template #filterContent>
      <v-row class="ma-0">
        <v-col cols="12" class="Form-Columns">
          <MultiSelect label="Status" name="admin-filter-driver-type" :items="FilterStatus" itemText="text"
            itemValue="value" hide-details="auto" v-model="filterObject.status" />
        </v-col>
        <v-col cols="12" class="Form-Columns">
          <MultiSelect label="Depot" name="depot-filter" :items="allDepot" itemText="depot_name" itemValue="depot_name"
            hide-details="auto" v-model="filterObject.depot" />
        </v-col>
        <v-col cols="12" class="Form-Columns">
          <DateField :inputProps="{
            dense: true,
            label: 'Next Availability Date ',
            'hide-details': 'auto',
          }" v-model="filterObject.next_availability_date" />
        </v-col>
      </v-row>
    </template>

    <template #filterAction>
      <v-btn color="secondary" depressed name="vehicle-filter-reset"
        @click="$emit('resetFilters'), (showTransporterVehicleFilter = false)">
        Reset
      </v-btn>
      <v-btn color="primary" class="ml-4" depressed name="vehicle-filter-apply"
        @click="$emit('applyFilters'), (showTransporterVehicleFilter = false)">
        Apply
      </v-btn>
    </template>
  </FilterParent>
</template>

<script>
import MultiSelect from "@/components/FormBaseComponents/MultiSelect.vue";
import FilterParent from "@/components/General/FilterParent.vue";
import { FilterStatus } from "@/utils/choices";
import DateField from "@/components/FormBaseComponents/DateField.vue";

export default {
  components: {
    FilterParent,
    MultiSelect,
    DateField
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    bindingObject: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      allDriverList: [],
      FilterStatus,
      allDepot: [],
      allStatus: [
        { display_name: "Active", value: "Active" },
        { display_name: "Inactive", value: "Inactive" },
        { display_name: "Leave", value: "Leave" },
      ],
    };
  },
  watch: {
    value(val) {
      if (val) {
        this.getDriverList();
        this.getDepotList();
      }
    },
  },
  computed: {
    showTransporterVehicleFilter: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    filterObject: {
      get() {
        return this.bindingObject;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    getDepotList(params = {}) {
      params = {
        limit: "all",
      };
      this.$api.depot
        .getDepotList(params)
        .then((res) => {
          this.allDepot = res.data;
        })
        .catch((err) => {
          console.error(err);
          this.$bus.$emit("showLoader", false);
        });
    },
    getDriverList() {
      this.$bus.$emit("showLoader", true);
      this.$api.driver
        .getDriverSelectList({
          limit: "all",
        })
        .then((res) => {
          this.allDriverList = res.data;
          this.$bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          this.$bus.$emit("showLoader", false);
        });
    },
  },
};
</script>
